import React, {Component} from "react";
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import apiClient from "api/client";
import {userActions} from "../../authentication/_actions";
import connect from "react-redux/es/connect/connect";
import {withNamespaces} from "react-i18next";
import {AxiosHeader} from "../../functions/GlobalFunctions";

class DropDownFeatureContent extends Component {

    constructor(props) {
        super(props);
        this.handleSelect = this.handleSelect.bind(this);
        this.state = {
            loading: true,
            contentArray: []
        };

    }

    handleSelect(value) {
        this.props.handlerFromParent(value);
    }

    componentDidMount() {

        this.loadData();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        if (this.props.applicationId !== prevProps.applicationId) {
            this.loadData();
        }

        if (this.props.deviceType !== prevProps.deviceType) {
            this.loadData();
        }

        if (this.props.contentProvider !== prevProps.contentProvider) {
            this.loadData();
        }

        if (this.props.contentType !== prevProps.contentType) {
            this.loadData();
        }
    }


    loadData(){

        const url = process.env.REACT_APP_API_URL + "/Feature";

        let user = JSON.parse(localStorage.getItem('user'));
        let token = ""

        if (user) {
            token = user.token
        } else {
            this.props.dispatch(userActions.logoutUnauthorized());
        }

        let axiosConfig = {
            headers: {
                'X-Id-Token': token,
                'Content-Type': 'application/json'
            }
        };


        let postData = {
            type: 'getContent',
            application_id: this.props.applicationId,
            device_type: this.props.deviceType,
            content_provider: this.props.contentProvider,
            content_type: this.props.contentType,
        };


        apiClient.post(url, postData, axiosConfig)
            .then(res => {

                let temp = res.data;

                let contentArray = [];
                let obj = {};

                for (let i = 0; i < temp.length; i++) {

                    obj = {
                        value: temp[i].value.toString(),
                        label: temp[i].label
                    }

                    contentArray.push(obj)
                }

                const loading = false;

                this.setState({contentArray, loading});
            })
            .catch(error => {
                console.log(error);
            });

    }

    render() {
        return (
            <Select
                placeholder="Content Select"
                name="contentSelect"
                autoFocus={false}
                multi={true}
                searchable={true}
                value={this.props.contentSelected}
                options={this.state.contentArray}
                onChange={value => this.handleSelect(value)}

            />
        );
    }

}

function mapStateToProps(state) {

    const {authentication} = state;
    const {user} = authentication;
    return {
        user
    };
}

const connectedDropDownFeatureContent = connect(mapStateToProps)(DropDownFeatureContent);
const connectedDropDownFeatureContentTrans = withNamespaces('common')(connectedDropDownFeatureContent);
export {connectedDropDownFeatureContentTrans as DropDownFeatureContent};

